import { useMutation } from "@tanstack/react-query";

import { useToasts } from "app/common/hooks";
import { translate } from "app/filters/i18nFilter";
import { createBenchmarkTrackerApi } from "app/pages/benchmark-tracker/services/api";

const UNSUBSCRIBE_TO_DIGEST_MUTATION_KEY = "UNSUBSCRIBE-TO-DIGEST";

export const useDigestUnsubscribe = (benchmarkId: string) => {
    const { showErrorToast } = useToasts();

    return useMutation({
        mutationKey: [UNSUBSCRIBE_TO_DIGEST_MUTATION_KEY],
        mutationFn: () => {
            const api = createBenchmarkTrackerApi();

            return api.report.unsubscribeFromDigest(benchmarkId);
        },

        onError(error: Error) {
            showErrorToast(translate("common.api.error", { error: error?.message }));
        },
    });
};
